import { Link } from "react-router-dom";
import { Seo } from "@/lib/seo";
import { NotFoundView } from "@/components/NotFoundView";

// Distinguishes a genuine 404 (entity truly missing → noindex + /404 canonical) from a
// transient fetch failure (network / 5xx / robots-blocked → keep the URL indexable so a
// temporary blip never deindexes a valid page). Never masks a nonexistent route.
export function DetailError({ error, path, notFound = false }) {
  const status = error?.response?.status;
  if (notFound || status === 404) return <NotFoundView />;
  return (
    <>
      <Seo
        title="Just a moment | Hotelstrips"
        description="This page is loading slowly or is briefly unavailable. Please try again in a moment."
        path={path}
      />
      <div data-testid="transient-error" className="mx-auto max-w-2xl px-5 sm:px-8 py-28 text-center">
        <div className="overline text-primary mb-3">Temporarily unavailable</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter text-ink">Just a moment</h1>
        <p className="text-muted-foreground mt-4 max-w-md mx-auto leading-relaxed">
          We're having trouble loading this page right now. Please refresh in a moment.
        </p>
        <div className="mt-8">
          <Link
            to={path}
            reloadDocument
            data-testid="transient-retry"
            className="inline-flex items-center rounded-full bg-primary px-6 py-3 text-sm font-heading font-semibold text-white hover:opacity-90 transition-opacity"
          >
            Retry
          </Link>
        </div>
      </div>
    </>
  );
}
